/* tslint:disable */
/* eslint-disable */
/**
 * mindd-payhub-server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { PaymentCard } from '../model';
// @ts-ignore
import type { PaymentCardRegistrations } from '../model';
/**
 * PaymentCardApi - axios parameter creator
 * @export
 */
export const PaymentCardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 결제 카드 변경
         * @param {string} receiptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeCard: async (receiptId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'receiptId' is not null or undefined
            assertParamExists('changeCard', 'receiptId', receiptId)
            const localVarPath = `/api/v1/cards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (receiptId !== undefined) {
                localVarQueryParameter['receiptId'] = receiptId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 결제 카드 삭제
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCard: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/cards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 결제 카드 정보 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCard: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/cards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 카드 등록 정보 목록 조회 (Y_ADMIN, Y_MANAGER, Y_OPERATOR, Y_DISTRIBUTOR)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/cards/registrations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 결제 카드 등록
         * @param {string} receiptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerCard: async (receiptId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'receiptId' is not null or undefined
            assertParamExists('registerCard', 'receiptId', receiptId)
            const localVarPath = `/api/v1/cards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (receiptId !== undefined) {
                localVarQueryParameter['receiptId'] = receiptId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentCardApi - functional programming interface
 * @export
 */
export const PaymentCardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentCardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 결제 카드 변경
         * @param {string} receiptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeCard(receiptId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentCard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeCard(receiptId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentCardApi.changeCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 결제 카드 삭제
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCard(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCard(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentCardApi.deleteCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 결제 카드 정보 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCard(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentCard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCard(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentCardApi.getCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 카드 등록 정보 목록 조회 (Y_ADMIN, Y_MANAGER, Y_OPERATOR, Y_DISTRIBUTOR)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegistrations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentCardRegistrations>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegistrations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentCardApi.getRegistrations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 결제 카드 등록
         * @param {string} receiptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerCard(receiptId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentCard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerCard(receiptId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentCardApi.registerCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentCardApi - factory interface
 * @export
 */
export const PaymentCardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentCardApiFp(configuration)
    return {
        /**
         * 
         * @summary 결제 카드 변경
         * @param {string} receiptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeCard(receiptId: string, options?: any): AxiosPromise<PaymentCard> {
            return localVarFp.changeCard(receiptId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 결제 카드 삭제
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCard(options?: any): AxiosPromise<void> {
            return localVarFp.deleteCard(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 결제 카드 정보 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCard(options?: any): AxiosPromise<PaymentCard> {
            return localVarFp.getCard(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 카드 등록 정보 목록 조회 (Y_ADMIN, Y_MANAGER, Y_OPERATOR, Y_DISTRIBUTOR)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrations(options?: any): AxiosPromise<PaymentCardRegistrations> {
            return localVarFp.getRegistrations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 결제 카드 등록
         * @param {string} receiptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerCard(receiptId: string, options?: any): AxiosPromise<PaymentCard> {
            return localVarFp.registerCard(receiptId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentCardApi - object-oriented interface
 * @export
 * @class PaymentCardApi
 * @extends {BaseAPI}
 */
export class PaymentCardApi extends BaseAPI {
    /**
     * 
     * @summary 결제 카드 변경
     * @param {string} receiptId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentCardApi
     */
    public changeCard(receiptId: string, options?: RawAxiosRequestConfig) {
        return PaymentCardApiFp(this.configuration).changeCard(receiptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 결제 카드 삭제
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentCardApi
     */
    public deleteCard(options?: RawAxiosRequestConfig) {
        return PaymentCardApiFp(this.configuration).deleteCard(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 결제 카드 정보 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentCardApi
     */
    public getCard(options?: RawAxiosRequestConfig) {
        return PaymentCardApiFp(this.configuration).getCard(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 카드 등록 정보 목록 조회 (Y_ADMIN, Y_MANAGER, Y_OPERATOR, Y_DISTRIBUTOR)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentCardApi
     */
    public getRegistrations(options?: RawAxiosRequestConfig) {
        return PaymentCardApiFp(this.configuration).getRegistrations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 결제 카드 등록
     * @param {string} receiptId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentCardApi
     */
    public registerCard(receiptId: string, options?: RawAxiosRequestConfig) {
        return PaymentCardApiFp(this.configuration).registerCard(receiptId, options).then((request) => request(this.axios, this.basePath));
    }
}

